module.exports = __webpack_public_path__ + "media/images/icon__info--white@2x-22d78b85c6bad803e7592af7bb6bcaf2.png";